<template>
  <div class="bg-white form-sign-up shadow rounded-lg">
    <form class="p-4">
        <div class="form-group">
            <label>{{ trans('programme.register_modal_title') }}</label>
            <select
            v-model="selected.agency_id"
            @change="loadProgramme()"
            class="form-control form-control-lg border-0 bg-gray"
            :class="{'is-invalid': $v.selected.agency_id.$error}"
            >
            <option :value="null">{{ trans('programme.organiser_select') }}</option>
            <option
                v-for="organiser in organisers"
                :key="organiser.id"
                :value="organiser.id"
            >{{ organiser.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <label>{{ trans('programme.programme_name') }}</label>
            <select
                v-model="selected.programme"
                @change="loadSchedule()"
                class="form-control form-control-lg border-0 bg-gray"
                :class="{'is-invalid': $v.selected.programme.$error}"
            >
                <option :value="null">{{ trans('programme.programme_select') }}</option>
                <option
                    v-for="programme in programmes"
                    :key="programme.id"
                    :value="programme"
                >{{ programme.name }}</option>
            </select>
        </div>
        <template v-if="selected.programme">
        <div class="form-group" v-if="selected.programme.is_private">
            <label>{{ trans('joining.access-code') }}</label>
            <input
                type="text"
                v-model="selected.access_code"
                class="form-control form-control-lg bg-gray border-0"
            />
            <small>{{ trans('joining.access-code-sub') }}</small>
        </div>
        </template>
        <div class="form-group">
            <label>{{ trans('programme.state') }}</label>
            <select
            v-model="selected.schedule_id"
            @change="loadScheduleTime()"
            class="form-control form-control-lg border-0 bg-gray"
            :class="{'is-invalid': $v.selected.schedule_id.$error}"
            >
            <option :value="null">{{ trans('programme.state_select') }}</option>
            <option
                v-for="schedule in schedules"
                :key="schedule.id"
                :value="schedule.id"
            >{{ schedule.state.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <label>{{ trans('programme.date') }}</label>
            <select
            v-model="selected.schedule_time_id"
            class="form-control form-control-lg border-0 bg-gray"
            :class="{'is-invalid': $v.selected.schedule_time_id.$error}"
            >
            <option :value="null">{{ trans('programme.date_select') }}</option>
            <option
                v-for="schedules_time in schedules_times"
                :key="schedules_time.id"
                :value="schedules_time.id"
            >
                {{ schedules_time.started_at | moment("DD MMMM YYYY") }}
                -
                {{ schedules_time.ended_at | moment("DD MMMM YYYY") }}
            </option>
            </select>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <p class="text-danger" v-if="$v.$error">{{ trans('global.form-fill-error') }}</p>
            </div>
        </div>
        <div class="mt-4">
            <button
            type="button"
            @click="submit_store"
            class="btn btn-block btn-primary py-3"
            >{{ trans('programme.join') }}</button>
        </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
    data() {
        return this.initData();
    },
    mounted() {
        this.loadOrganiser();
    },
    validations: {
        selected: {
            agency_id: { required },
            programme: { required },
            schedule_id: { required },
            schedule_time_id: { required },
        },
    },
    methods: {
        initData() {
            return {
                organisers: [],
                programmes: [],
                schedules: [],
                schedules_times: [],
                selected: {
                    agency_id: null,
                    programme: null,
                    access_code: null,
                    schedule_id: null,
                    schedule_time_id: null,
                },
            };
        },
        async loadOrganiser() {
            let loader = this.$loading.show();
            try {
                const { data } = await axios.get(route("api.agencies.index"));
                this.organisers = data;
                loader.hide();
            } catch (e) {
                loader.hide();
                this.errorPopup(e.response.data.message);
            }
        },
        async loadProgramme() {
            let loader = this.$loading.show();
            this.selected.programme = this.initData().selected.programme;
            this.selected.schedule_id = this.initData().selected.schedule_id;
            this.selected.schedule_time_id = this.initData().selected.schedule_time_id;
            this.programmes = this.initData().programmes;
            this.schedules = this.initData().schedules;
            this.schedules_times = this.initData().schedules_times;
            try {
                const { data } = await axios.post(route("api.programmes.list"), {
                agency_id: this.selected.agency_id,
                });
                this.programmes = data;
                loader.hide();
            } catch (e) {
                loader.hide();
                this.errorPopup(e.response.data.message);
            }
        },
        async loadSchedule() {
            let loader = this.$loading.show();
            this.selected.schedule_id = this.initData().selected.schedule_id;
            this.selected.schedule_time_id = this.initData().selected.schedule_time_id;
            this.schedules = this.initData().schedules;
            this.schedules_times = this.initData().schedules_times;
            try {
                const { data } = await axios.post(route("api.schedules.list"), {
                    programme_id: this.selected.programme.id,
                });
                this.schedules = data;
                loader.hide();
            } catch (e) {
                loader.hide();
                this.errorPopup(e.response.data.message);
            }
        },
        async loadScheduleTime() {
            let loader = this.$loading.show();
            this.selected.schedule_time_id = this.initData().selected.schedule_time_id;
            this.schedules_times = this.initData().schedules_times;
            try {
                const { data } = await axios.post(route("api.schedules.times"), {
                schedule_id: this.selected.schedule_id,
                });
                this.schedules_times = data;
                loader.hide();
            } catch (e) {
                loader.hide();
                this.errorPopup(e.response.data.message);
            }
        },
        handleOk() {
            this.submit_store();
        },
        async submit_store() {
            console.log("submit");
            let loader = this.$loading.show();
            this.$v.$touch();
            if (this.$v.$invalid) {
                loader.hide();
            } else {
                try {
                    const { data } = await axios.post(
                        route("api.programmes.participate"),
                        {
                            selected: this.selected,
                        }
                    );
                    loader.hide();
                    window.location.href = route("en.test");
                } catch (e) {
                    loader.hide();
                    this.errorPopup(e.response.data.message);
                }
            }
        },
    },
};
</script>
